import { FetcherAmplify } from './FetcherAmplify';

const fetcherAmplify = new FetcherAmplify();

export { fetcherAmplify };
